import { isNumber } from '@doltech/utils/lib/number';
import cl from 'classnames';
import * as React from 'react';

import { QuestionContainer } from './components';
import { QuestionV2 } from '../Question/QuestionV2';

interface DragInProps extends React.HTMLAttributes<HTMLSpanElement> {
  number?: number | string;
  answer?: string;
  text?: string;
}

export const DragInBase = (props: DragInProps, ref: React.Ref<HTMLSpanElement>) => {
  const { className = 'default', number, answer, text, ...rest } = props;
  return (
    <QuestionContainer className={cl(className)} ref={ref} {...rest}>
      {isNumber(number) ? <QuestionV2 no={number} noArrow style={{ marginRight: 8 }} /> : null}
      {answer !== null ? <span className={cl('answer')}>{answer}</span> : null}
      {text ? <span className={cl('text')}>{text}</span> : null}
    </QuestionContainer>
  );
};

export const DragIn = React.memo(React.forwardRef(DragInBase));
